module.exports = __webpack_public_path__ + "img/ad2.0922519b.png";